import React, { FC } from "react";
import styled from "styled-components/macro";
import Module from "shared/lib/interfaces/Module";
import ModuleSection from "shared/lib/interfaces/ModuleSection";
import SlidePage, { SlidePageProgress, SlidePageProps } from "../../SlidePage";

interface Props {
  module: Pick<Module, "icon" | "name">;
  section: Pick<ModuleSection, "name">;
  progress: SlidePageProgress;
  onNext: SlidePageProps["onNext"];
  onBack: SlidePageProps["onBack"];
}

const RulesAndConsequencesSlide12: FC<Props> = (props) => {
  const { module, section, ...rest } = props;

  return (
    <SlidePage {...rest} title={module.name}>
      <section>
        <h3>LOGICAL CONSEQUENCES</h3>
        <p>
          When children have trouble following directions, they may need
          consequences to their behavior. The most effective way to support your
          clear rules is to use logical consequences.
          <br />
          <br />
          Logical consequences make sense because they are linked to the
          behavior you are trying to change.
        </p>
      </section>
    </SlidePage>
  );
};

export default styled(RulesAndConsequencesSlide12)``;
